import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getDialogsConfigs() {
    return {
        palette: {
            [PALETTE_IDS.DIALOGS]: {
                DIALOGS_CONTAINER_BG: COLOR.BRAND.BACKGROUND4,
            },
            [PALETTE_IDS.AUTO_CASHOUT_DIALOG]: {
                AC_DIALOG_TITLE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
            },
            [PALETTE_IDS.COMBINATION_ODDS_POPUP]: {
                COMBINATION_ODDS_CLOSE_BUTTON: {
                    CLOSE_BUTTON_ICON_COLOR: COLOR.BRAND.FOREGROUND2,
                },
                COMBINATION_ODDS_HEADER_TEXT: COLOR.BRAND.FOREGROUND2,
                COMBINATION_ODDS_HEADER_SHOW_SEPARATOR: false,
            },
            [PALETTE_IDS.QUICK_START_GUIDE]: {
                QSG_DIALOG_SKELETON_PART: {
                    SKELETON_COLOR: COLOR.BRAND.BACKGROUND3,
                },
                QSG_BANNER_CONTAINER_BG: COLOR.BRAND.BACKGROUND2,
            },
        },
    };
}
